export default __webpack_public_path__ + "images/assets/1eb56e920106b531476b3e4c69a06445.svg";